var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInboxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,13.86c0-.34-.59-2.46-3-12.1A1,1,0,0,0,19,1H5a1,1,0,0,0-1,.76c-2.42,9.66-2.95,11.76-3,12.1s0-1,0,8.14a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1C23,12.68,23,14.16,23,13.86ZM5.78,3H18.22l2.5,10H16a1,1,0,0,0-1,1,3,3,0,0,1-6,0,1,1,0,0,0-1-1H3.28ZM21,21H3V15H7.1a5,5,0,0,0,9.8,0H21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.29,12.71a1,1,0,0,0,1.42,0l2.5-2.5a1,1,0,0,0-1.42-1.42l-.79.8V5a1,1,0,0,0-2,0V9.59l-.79-.8a1,1,0,0,0-1.42,1.42Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIcon);
export default __webpack_public_path__ + "static/media/inbox-icon.6b2ad8cb3e3cb61f125e49418c3d0779.svg";
export { ForwardRef as ReactComponent };